var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.958,
    height: 63.521,
    viewBox: "0 0 62.958 63.521",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158",
    transform: "translate(-1023.542 -498.941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1860",
    "data-name": "Path 1860",
    d: "M1086.5,530.7a31.48,31.48,0,1,1-31.479-31.76A31.62,31.62,0,0,1,1086.5,530.7",
    transform: "translate(0 0)",
    fill: "#add095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1861",
    "data-name": "Path 1861",
    d: "M1045.046,540.508v-19.38c0-1.069,1.21-1.938,2.7-1.938s2.7.869,2.7,1.938v19.38c0,1.069-1.207,1.938-2.7,1.938s-2.7-.869-2.7-1.938",
    transform: "translate(7.276 6.851)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1862",
    "data-name": "Path 1862",
    d: "M1050.844,514.968a3.022,3.022,0,1,1-3.018-2.871,2.948,2.948,0,0,1,3.018,2.871",
    transform: "translate(7.195 4.451)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.d3cb0383ab194be70be25ed6350a2dfd.svg";
export { ForwardRef as ReactComponent };